export const selectors = {
  // Backtest Selectors
  openSettingsButton: '[data-tour-id="open-settings-button"]',
  backtestOpenSettings: '[data-tour-id="backtest-card"]:first-child',
  backtestName: '[data-tour-id="backtest-name"]',
  backtestPatternName: '[data-tour-id="backtest-pattern-name"]',
  backtestGrade: '[data-tour-id="backtest-grade"]:first-child',
  backtestSideNavigationTabSettings: '[data-tour-id="backtest-side-navigation-tab-settings"]',
  backtestSideNavigationTabReports: '[data-tour-id="backtest-side-navigation-tab-reports"]',
  backtestSideNavigationTabPattern: '[data-tour-id="backtest-side-navigation-tab-pattern"]',
  createAlertBacktestButton: '[data-tour-id="create-alert-button-backtest"]',
  favoriteBacktestIconButton: '[data-tour-id="favorite-backtest-icon-button"]',
  shareBacktestIconButton: '[data-tour-id="share-backtest-button"]',
  rerunBacktestButton: '[data-tour-id="rerun-backtest-button"]',
  viewBacktestButton: '[data-tour-id="view-backtest-button"]',
  backtestRunDialog: '[data-tour-id="backtest-run-dialog"]',
  backtestRunDialogCost: '[data-tour-id="backtest-run-dialog-cost"]',
  backtestRunDialogPlay: '[data-tour-id="backtest-run-dialog-play"]',
  backtestTypeSelectMenu: '[data-tour-id="type-select-menu"]',
  backtestTypeSelectButton: '[data-tour-id="type-select-button"]',
  backtestFiltersButton: '[data-tour-id="filter-button"]',

  // Alert Selectors
  alertPatternName: '[data-tour-id="alert-pattern-name"]',
  alertName: '[data-tour-id="alert-name"]',
  alertSettingsButton: '[data-tour-id="alert-settings-button"]',
  alertActiveSwitch: '[data-tour-id="alert-active-switch"]',
  alertContentSection: '[data-tour-id="alert-content-section"]',
  alertTypeIcons: '[data-tour-id="alert-type-icons"]',
  alertSidePanel: '[data-tour-id="alert-side-panel"]',
  alertSidePanelSettingsTab: '[data-tour-id="alert-side-panel-settings-tab"]',
  alertSidePanelHistoryTab: '[data-tour-id="alert-side-panel-history-tab"]',
  alertSidePanelPatternTab: '[data-tour-id="alert-side-panel-pattern-tab"]',
  alertSidePanelActions: '[data-tour-id="alert-side-panel-actions"]',
  createAlertButton: '[data-tour-id="create-alert-button"]',

  // Pattern Builder Selectors
  tradingHousePatternsSection: '[data-tour-id="trading-house-patterns-section"]',
  yourPatternsSection: '[data-tour-id="your-patterns-section"]',
  userPattern: '[data-tour-id="user-pattern"]',
  patternItem: '.your-patterns-section [data-tour-id="pattern-item"]:first-of-type',
  patternName: '.your-patterns-section [data-tour-id="pattern-name"]:first-child',
  patternBuyTab: '.your-patterns-section [data-tour-id="pattern-buy-sell-tab"]:first-child',
  patternSellTab: '[data-tour-id="pattern-sell-tab"]',
  triggerChartSelector: '[data-tour-id="trigger-chart-selector"]',
  userPatternGroup: '.your-patterns-section [data-tour-id="user-pattern-group"]',
  patternCondition: '.your-patterns-section [data-tour-id="pattern-condition"]',
  patternConditionHeader: '.your-patterns-section [data-tour-id="pattern-condition-header"]',
  conditionSelector: '.your-patterns-section [data-tour-id="condition-selector"]',
  addRuleButton: '.your-patterns-section [data-tour-id="add-item-button"]',
  patternConditionDragHandle:
    '.your-patterns-section [data-tour-id="pattern-condition-drag-handle"]',
  savePatternButton: '.your-patterns-section [data-tour-id="save-pattern-button"]',
  patternConditionButton: '.your-patterns-section [data-tour-id="pattern-condition-button"]',
  patternAlertsTab: '[data-tour-id="pattern-alerts-tab"]',
  patternBacktestsTab: '[data-tour-id="pattern-backtests-tab"]',
  patternVersionTab: '[data-tour-id="pattern-version-tab"]',
  patternActionsSection: '[data-tour-id="pattern-actions-section"]',
  patternCopyButton: '[data-tour-id="pattern-copy-button"]',
  patternSidePanel: '[data-tour-id="pattern-side-panel"]',
  createPatternButton: '[data-tour-id="create-pattern-button"]',
} as const
